import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { VisiteService } from '../_servizi/visite.service';
import * as moment from 'moment';
import { MatCalendar, MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { LoaderService } from '../_servizi/loader.service';
import { Subject } from 'rxjs';
import { DialogPromoComponent } from '../_dialoghi/dialog-promo/dialog-promo.component';
import { PromoService } from '../_servizi/promo.service';
import { StepService } from '../_servizi/step.service';
import { CantinaService } from '../_servizi/cantina.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CarrelloViniService } from '../_servizi/carrelloVini.service';
import { v4 as uuidv4 } from 'uuid';
import { MessageServiceService } from '../_servizi/message-service.service';
import { AppoggioService } from '../_servizi/appoggio.service';
import { StripeService } from '../_servizi/stripe.service';
import { DialogCarrelloPienoComponent } from '../_dialoghi/dialog-carrello-pieno/dialog-carrello-pieno.component';

function TRANSLATE(str: string) {
  return str;
}
@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: [
    './step1.component.css',
    '../../styles-purchase-page.css',
    '../../styles-typography.css'
  ]
})
export class Step1Component implements OnInit, OnDestroy, AfterViewInit {

  checkAbilitato = false;
  abilitato = false;
  nonabilitatoMsg = '';
  novisita = '';

  isLoading: Subject<boolean> = this.loaderService.isLoading;

  codiceForm: any;
  idTipoVisita: any;
  linguaCorrente: string;

  promoSelezionata = null;
  promoCW = null;
  totadultipromo = 0;

  cantina: any;
  tutteledate: any;
  dateTipoVistaSelezionata: any;
  visitaselezionata: any;
  indexVisitaPassata: any;

  immagini: any;
  vini: any;
  tipovisite: any;


  postiminimilabel = 0;

  nessunavisita = false;

  adulti = 1;
  adultiSoloVisita: number = 0;
  minori = 0;
  ridotti = 0;
  mobridotta = false;

  formLinguaSelezionata: UntypedFormGroup;
  lingueSplit = [];
  linguaSelezionataFormControl = new UntypedFormControl(null, []);
  erroreLingua = false;

  arrayOpzioni: any[];
  parametriOpzioniTipoVisita: any;
  countCheckOpzioni = 0;

  arrayGite: any[];
  parametriOpzioniGita: any;
  countCheckGite = 0;

  erroreGite = false;
  erroreOpzioni = false;

  showNote = false;
  showTermini = false;
  denominazione: any;

  ricercaFatta = false;


  myFilter = (d: any): boolean => {
    const datatest = d._d;
    let trovata = false;

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.tutteledate.length; i++) {
      const datavisita = this.tutteledate[i].data;
      if (moment(datavisita).isSame(moment(datatest), 'day')) {
        trovata = true;
        break;
      }
    }
    // Prevent Saturday and Sunday from being selected.
    return trovata;
  }

  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild(MatCalendar) calendar!: MatCalendar<Date>;

  refactor = true;

  dropdown_attivo = null;

  oggetto_posti = [
    { visibile: true, label: '', hint: '', prezzo: 0, numero: this.adulti, scelta: 'adulti' },
    { visibile: true, label: '', hint: '', prezzo: 0, numero: this.adultiSoloVisita, scelta: 'solovisita' },
    { visibile: true, label: '', hint: '', prezzo: 0, numero: this.ridotti, scelta: 'ridotti' },
    { visibile: true, label: '', hint: '', prezzo: 0, numero: this.minori, scelta: 'minori' },
  ];

  arrayRichieste = [
    { id: 1, label: TRANSLATE('base.stepper.step1.addons.animali'), qta: 0, icon: '../../../assets/img/addons/dog.png', solouna: '1', sottotitolo: null },
    { id: 2, label: TRANSLATE('base.stepper.step1.addons.vegani'), qta: 0, icon: '../../../assets/img/addons/vegan.png', solouna: '0', sottotitolo: null },
    { id: 3, label: TRANSLATE('base.stepper.step1.addons.vegetariani'), qta: 0, icon: '../../../assets/img/addons/vegetarian.png', solouna: '0', sottotitolo: null },
    { id: 4, label: TRANSLATE('base.stepper.step1.addons.celiaci'), qta: 0, icon: '../../../assets/img/addons/bread.png', solouna: '0', sottotitolo: null },
  ]

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    private visiteService: VisiteService,
    private adapter: DateAdapter<any>,
    public loaderService: LoaderService,
    private promoService: PromoService,
    private stepService: StepService,
    private cantinaService: CantinaService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    public carrelloService: CarrelloViniService,
    private messageService: MessageServiceService,
    private appoggioService: AppoggioService,
    private stripeService: StripeService
  ) {
    this.stepService.currentStep = 1;

    this.formLinguaSelezionata = this.fb.group({
      lingua: this.linguaSelezionataFormControl
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.codiceForm = params.get('cantina');
      this.idTipoVisita = params.get('visita');
      this.linguaCorrente = params.get('lingua');

      moment.locale(this.linguaCorrente)
      this.translate.use(this.linguaCorrente);
      this.adapter.setLocale(this.translate.currentLang);

      this.getInfoCantina(this.codiceForm);

      let idCookie = params.get('idCookie');

      if (idCookie && idCookie !== 'null' && idCookie !== undefined && idCookie !== 'undefined') {
        this.messageService.setIdCookie(idCookie);
      } else {
        idCookie = uuidv4();
        this.messageService.sendIdCookie(idCookie);
        this.messageService.setIdCookie(idCookie);
      }
    });
  }

  ngOnDestroy(): void {
  }

  ngAfterViewInit(): void {
    this.aggiungiDataLingueAttr();
    this.agganciaEventiCambioMese();
  }

  getInfoCantina(codiceForm): void {
    this.cantinaService.getStato(codiceForm)
      .subscribe(cantina => {
        this.checkAbilitato = true;
        if (cantina && cantina.length > 0) {
          this.stepService.cantinaDenominazione = cantina[0].denominazione;
          const clientUrl = document.referrer;

          this.abilitato = true;
          this.stepService.admPagaCantina = cantina[0].pagaCantina === '1' ? true : false;
          this.stepService.admPagaCantinaSC = cantina[0].pagaCantinaSC === '1' ? true : false;
          this.stepService.pagaCantinaInsite = cantina[0].pagaCantina === '1' ? true : false;
          this.getDetteglioVisita(this.linguaCorrente, this.codiceForm, this.idTipoVisita);
          this.getOpzioniExtra(this.idTipoVisita);
          this.getOpzioniGite(this.idTipoVisita);

          if (cantina[0]['infoStripe'] != null) {
            const infoStripe = {
              abilitatoAccount: cantina[0]['infoStripe']['abilitatoAccountStripe'] === '1' ? true : false,
              abilitatoProduzione: cantina[0]['infoStripe']['abilitatoProduzione'] === '1' ? true : false,
              api_key: cantina[0]['infoStripe']['abilitatoProduzione'] === '1' ? cantina[0]['infoStripe']['apiKeyStripeProduzione'] : cantina[0]['infoStripe']['apiKeyStripeTest'],
              endpoint_secret: cantina[0]['infoStripe']['abilitatoProduzione'] === '1' ? cantina[0]['infoStripe']['endpointSecretProduzione'] : cantina[0]['infoStripe']['endpointSecretTest']
            }
            this.stripeService.setInfoStripe(infoStripe);
          } else {
            this.stripeService.setInfoStripe(null);
          }



          this.appoggioService.setColoriIframe(cantina[0]);

        } else {
          this.abilitato = false;
          this.nonabilitatoMsg = 'nonAbilitato';
        }
      });
  }

  getDetteglioVisita(lingua, codiceForm, idTipoVisita): void {
    this.visiteService.getVisitaDetails(lingua, codiceForm, idTipoVisita)
      .subscribe(cantina => {
        this.ricercaFatta = true;
        if (cantina.visitaselezionata) {
          this.cantina = cantina.info;
          this.stepService.richiediDatiFiscaliRicevuta = this.cantina.richiediDatiFiscaliRicevuta === '1' ? true : false;

          this.cantina.lat = parseFloat(this.cantina.lat);
          this.cantina.lng = parseFloat(this.cantina.lng);

          this.tutteledate = cantina.altredate;
          this.settaComboOra(cantina.visitaselezionata.data.split('T')[0], false);

          /*
          if (!isNaN(idVisita)) {
            for (let i = 0; i < this.dateTipoVistaSelezionata.length; i++) {
              if (parseInt(this.dateTipoVistaSelezionata[i].id, 10) === idVisita) {
                this.indexVisitaPassata = i;
              }
            }
            this.visitaselezionata = this.dateTipoVistaSelezionata[this.indexVisitaPassata];
          } else {
            this.indexVisitaPassata = 0;
            this.visitaselezionata = this.dateTipoVistaSelezionata[0];
          }*/

          this.indexVisitaPassata = 0;
          this.visitaselezionata = this.dateTipoVistaSelezionata[0];

          this.immagini = cantina.immagini;
          this.vini = cantina.vini;
          this.tipovisite = cantina.tipovisite;
          this.visitaselezionata = cantina.visitaselezionata;

          this.gestisciAdulti(true);

          this.sistemaComboLingua();
          this.settaOpzioniTipoVisita();
          this.settaOpzioniGite();
          this.getRichiesteParticolari();
          this.getDettaglioPromoCantinaLibera(this.visitaselezionata.id);
        } else {
          this.nessunavisita = true;
          this.denominazione = cantina.info.denominazione;
        }

      });
  }

  getDettaglioPromoCantinaLibera($idVisita) {
    this.promoService.getDettaglioPromoCantinaLibera($idVisita, this.cantina.codiceForm)
      .subscribe(promo => {
        if (promo) {
          this.controllaPromoLibera(promo);
        }
      });
  }

  controllaPromoLibera(promo) {
    const przvisita = this.prezzoSingolo;
    const totaleadulti = przvisita * this.adulti;
    this.promoSelezionata = this.promoService.controllaPromo(promo, this.adulti, totaleadulti, przvisita, promo.codice);
  }

  getRichiesteParticolari() {
    this.visiteService.getRichiesteParticolari(this.cantina.codiceForm, this.translate.currentLang).subscribe(response => {
      let i = 0;
      for (const richiesta of response) {
        this.arrayRichieste[i].sottotitolo = richiesta.sottotitolo;
        i++;
      }
    });
  }


  sistemaComboLingua() {
    if (this.visitaselezionata) {
      if (this.visitaselezionata.lingua) {
        this.lingueSplit = this.visitaselezionata.lingua.split(';');
        this.formLinguaSelezionata.patchValue({
          lingua: null
        });
        this.formLinguaSelezionata.updateValueAndValidity();
      }
    }
  }

  settaOpzioniTipoVisita() {
    this.parametriOpzioniTipoVisita = {
      obbligatorie: this.visitaselezionata.opzioniObbligatorie === '1' ? true : false,
      singole: this.visitaselezionata.opzioniSingole === '1' ? true : false,
    };
  }

  settaOpzioniGite() {
    this.parametriOpzioniGita = {
      obbligatorie: this.visitaselezionata.giteObbligatorie === '1' ? true : false,
      singole: this.visitaselezionata.giteSingole === '1' ? true : false,
    };
  }

  settaComboOra(datatest, selezionaprima) {
    this.dateTipoVistaSelezionata = [];
    for (let i = 0; i < this.tutteledate.length; i++) {
      const datavisita = this.tutteledate[i].data;
      if (moment(datavisita).isSame(moment(datatest), 'day')) {
        this.dateTipoVistaSelezionata.push(this.tutteledate[i]);
      }
    }
    if (selezionaprima) {
      this.visitaselezionata = this.dateTipoVistaSelezionata[0];
      this.getDettaglioPromoCantinaLibera(this.visitaselezionata.id);
      this.indexVisitaPassata = 0;
      this.sistemaComboLingua();
      this.gestisciAdulti(true);
    }
  }

  settaOrari(event: any) {
    this.promoSelezionata = null;
    this.promoCW = null;
    const datatest = event.format('YYYY-MM-DD');
    this.settaComboOra(datatest, true);
  }

  cambiaVisita(indexTutteledate) {
    this.promoSelezionata = null;
    this.promoCW = null;
    this.visitaselezionata = this.dateTipoVistaSelezionata[indexTutteledate];
    this.getDettaglioPromoCantinaLibera(this.visitaselezionata.id);
    this.sistemaComboLingua();
  }

  aggiungiDataLingueAttr() {
    setTimeout(() => {
      const celle = document.querySelectorAll('.mat-calendar-body-cell');
      const activeMoment = moment(this.calendar?.activeDate);
      const mese = activeMoment.month();
      const anno = activeMoment.year();

      celle.forEach((cella: any) => {
        cella.removeAttribute('data-lingue'); // Pulizia

        const giornoText = cella.innerText.trim().split('\n')[0];
        const giorno = parseInt(giornoText, 10);
        if (isNaN(giorno)) return;

        const dataCella = moment({ year: anno, month: mese, day: giorno });

        const voce = this.tutteledate?.find(d =>
          moment(d.data).isSame(dataCella, 'day')
        );

        if (voce?.lingua) {
          const lingue = voce.lingua
            .split(';')
            .map(l => l.trim())
            .filter(l => l)
            .join(', ');
          cella.setAttribute('data-lingue', lingue);
        }
      });
    }, 0);
  }

  aggiungiClassiConLingue = (date: Date): string => {
    const voce = this.tutteledate?.find(d => moment(d.data).isSame(date, 'day'));
    if (voce?.lingua) {
      const lingue = voce.lingua.split(';').map(l => l.trim()).filter(l => l);
      return 'lingue-' + lingue.join('-'); // es: lingue-it-en-de
    }
    return '';
  };

  agganciaEventiCambioMese() {
    const nextBtn = document.querySelector('.mat-calendar-next-button');
    const prevBtn = document.querySelector('.mat-calendar-previous-button');

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        setTimeout(() => this.aggiungiDataLingueAttr(), 10); // DOM aggiornato
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        setTimeout(() => this.aggiungiDataLingueAttr(), 10);
      });
    }
  }

  gestisciAdulti(cancellaSoloVisita: boolean) {
    if (parseInt(this.visitaselezionata.prenotati, 10) >= parseInt(this.visitaselezionata.min, 10)) {
      this.adulti = parseInt(this.visitaselezionata.multipli, 10);
      this.postiminimilabel = parseInt(this.visitaselezionata.multipli, 10);
    } else {
      this.adulti = parseInt(this.visitaselezionata.min, 10);
      this.postiminimilabel = parseInt(this.visitaselezionata.min, 10);
    }
    if (cancellaSoloVisita) {
      this.adultiSoloVisita = 0;
    }
    this.aggiornaOggettoPosti();
  }

  aggiornaOggettoPosti() {
    const przAdulti = this.prezzoSingolo;
    const przAdultiSoloVisita = this.visitaselezionata.costo_solovisita ? parseFloat(this.visitaselezionata.costo_solovisita) : 0;
    const przMinori = 0;
    const przRidotti = parseFloat(this.visitaselezionata.costoridotti);

    this.oggetto_posti = [
      { visibile: true, label: this.translate.instant('pagina_acquisto.scelte.plurale.adulti'), hint: '', prezzo: przAdulti, numero: this.adulti, scelta: 'adulti' },
      { visibile: this.showAdultiSoloVisita(), label: this.translate.instant('pagina_acquisto.scelte.plurale.adulti_solovisita'), hint: '', prezzo: przAdultiSoloVisita, numero: this.adultiSoloVisita, scelta: 'solovisita' },
      {
        visibile: this.showRidotti(), label: this.translate.instant('pagina_acquisto.scelte.plurale.ridotti'), hint: this.translate.instant('pagina_acquisto.da') + ' ' + this.visitaselezionata.age1ridotti + ' ' + this.translate.instant('pagina_acquisto.a') + ' ' +
          this.visitaselezionata.age2ridotti, prezzo: przRidotti, numero: this.ridotti, scelta: 'ridotti'
      },
      {
        visibile: true, label: this.translate.instant('pagina_acquisto.scelte.plurale.minori'), hint: this.translate.instant('pagina_acquisto.da') + ' ' + this.visitaselezionata.age1minori + ' ' + this.translate.instant('pagina_acquisto.a') + ' ' +
          this.visitaselezionata.age2minori, prezzo: przMinori, numero: this.minori, scelta: 'minori'
      }
    ];
  }

  get oggetto_posti_filtered() {
    return this.oggetto_posti.filter(item => item.visibile);
  }

  get stringa_posti(): string {
    const sceltaLabels: { [key: string]: { singolare: string, plurale: string } } = {
      'adulti': { singolare: this.translate.instant('pagina_acquisto.scelte.singolare.adulti'), plurale: this.translate.instant('pagina_acquisto.scelte.plurale.adulti') },
      'solovisita': { singolare: this.translate.instant('pagina_acquisto.scelte.singolare.adulti_solovisita'), plurale: this.translate.instant('pagina_acquisto.scelte.plurale.adulti_solovisita') },
      'ridotti': { singolare: this.translate.instant('pagina_acquisto.scelte.singolare.ridotti'), plurale: this.translate.instant('pagina_acquisto.scelte.plurale.ridotti') },
      'minori': { singolare: this.translate.instant('pagina_acquisto.scelte.singolare.minori'), plurale: this.translate.instant('pagina_acquisto.scelte.plurale.minori') }
    };

    const postiSelezionati = this.oggetto_posti.filter(posto => posto.numero >= 1);

    const result = postiSelezionati.map(posto => {
      const labelData = sceltaLabels[posto.scelta] || { singolare: posto.scelta, plurale: posto.scelta };
      const label = posto.numero > 1 ? labelData.plurale : labelData.singolare;
      return `${posto.numero} ${label}`;
    });
    return result.join(', ');
  }

  setLang(lingua) {
    this.linguaSelezionataFormControl = lingua;
    this.formLinguaSelezionata.patchValue({
      lingua: lingua
    })
  }

  postiMeno(scelta: string) {
    switch (scelta) {
      case 'adulti':
        this.adultiMeno();
        break;
      case 'solovisita':
        this.adultiSoloVisitaMeno();
        break;
      case 'minori':
        this.minoriMeno();
        break;
      case 'ridotti':
        this.ridottiMeno();
        break;
    }
    this.aggiornaOggettoPosti();
  }
  postiPiu(scelta: string) {
    switch (scelta) {
      case 'adulti':
        this.adultiPiu();
        break;
      case 'solovisita':
        this.adultiSoloVisitaPiu();
        break;
      case 'minori':
        this.minoriPiu();
        break;
      case 'ridotti':
        this.ridottiPiu();
        break;
    }
    this.aggiornaOggettoPosti();
  }


  adultiMeno() {
    const multipli = parseInt(this.visitaselezionata.multipli, 10);
    const prenotati = parseInt(this.visitaselezionata.prenotati, 10);
    const min = parseInt(this.visitaselezionata.min, 10);

    if (this.adulti - multipli >= (prenotati >= min ? 1 : min)) {

      this.adulti -= multipli;
      const adultiMinori = this.cantina.adulti_minori.split(':');
      const maxMinori = parseInt(adultiMinori[1], 10) * this.adulti;
      if (this.minori > maxMinori) {
        this.minori = maxMinori;
      }
    }

    if (this.visitaHasRange()) {
      const totalIndex = this.visitaselezionata.rangecosti.length - 1;
      for (const range of this.visitaselezionata.rangecosti) {
        const isUltimo = this.visitaselezionata.rangecosti.lastIndexOf(range) == totalIndex ? true : false;
        if (parseInt(range.min, 10) <= this.adulti && (parseInt(range.max, 10) >= this.adulti || isUltimo || parseInt(range.max, 10) == 0)) {
          range.selezionato = true;
        } else {
          range.selezionato = false;
        }
      }
    }


    for (const gita of this.arrayGite) {
      if (gita.qta > 0) {
        gita.qta = this.adultiSoloVisita + this.adulti;
      }
    }

    for (const opzione of this.arrayOpzioni) {
      if (opzione.qta > 0 && opzione.qta >= this.adulti + this.adultiSoloVisita) {
        opzione.qta = this.adulti + this.adultiSoloVisita;
      }
    }

    for (const richiesta of this.arrayRichieste) {
      if (richiesta.qta > 0 && richiesta.qta >= this.adulti + this.adultiSoloVisita) {
        richiesta.qta = this.adulti + this.adultiSoloVisita;
      }
    }
  }

  adultiPiu() {
    const max = parseInt(this.visitaselezionata.max, 10);
    const prenotati = parseInt(this.visitaselezionata.prenotati, 10);
    const multipli = parseInt(this.visitaselezionata.multipli, 10);
    const postidisponibili = max - prenotati;

    if (this.adulti + this.adultiSoloVisita + multipli + this.ridotti <= postidisponibili) {
      this.adulti += multipli;
    }

    if (this.visitaHasRange()) {
      const totalIndex = this.visitaselezionata.rangecosti.length - 1;
      for (const range of this.visitaselezionata.rangecosti) {
        const isUltimo = this.visitaselezionata.rangecosti.lastIndexOf(range) == totalIndex ? true : false;
        if (parseInt(range.min, 10) <= this.adulti && (parseInt(range.max, 10) >= this.adulti || isUltimo || parseInt(range.max, 10) == 0)) {
          range.selezionato = true;
        } else {
          range.selezionato = false;
        }
      }
    }

    for (const gita of this.arrayGite) {
      if (gita.qta > 0) {
        gita.qta = this.adulti + this.adultiSoloVisita;
      }
    }
  }

  adultiSoloVisitaMeno() {
    const multipli = parseInt(this.visitaselezionata.multipli, 10);

    if (
      this.adultiSoloVisita > 0
    ) {

      this.adultiSoloVisita -= multipli;
      const adulti_minori = this.cantina.adulti_minori.split(':');

      const maxMinori = parseInt(adulti_minori[1], 10) * this.adultiSoloVisita;
      if (this.minori > maxMinori) {
        this.minori = maxMinori;
      }
    }

    for (const gita of this.arrayGite) {
      if (gita.qta > 0) {
        gita.qta = this.adultiSoloVisita + this.adulti;
      }
    }

    for (const opzione of this.arrayOpzioni) {
      if (opzione.qta > 0 && opzione.qta >= this.adultiSoloVisita + this.adulti) {
        opzione.qta = this.adultiSoloVisita + this.adulti;
      }
    }
  }

  adultiSoloVisitaPiu() {
    const max = parseInt(this.visitaselezionata.max, 10);
    const prenotati = parseInt(this.visitaselezionata.prenotati, 10);
    const multipli = parseInt(this.visitaselezionata.multipli, 10);
    const postidisponibili = max - prenotati;

    if (this.adultiSoloVisita + multipli + this.ridotti + this.adulti <= postidisponibili) {
      this.adultiSoloVisita += multipli;
    }

    for (const gita of this.arrayGite) {
      if (gita.qta > 0) {
        gita.qta = this.adultiSoloVisita + this.adulti;
      }
    }
  }

  ridottiMeno() {
    if (this.ridotti > 0) {
      this.ridotti -= 1;
    }
  }

  ridottiPiu() {
    const max = parseInt(this.visitaselezionata.max, 10);
    const prenotati = parseInt(this.visitaselezionata.prenotati, 10);
    const multipli = parseInt(this.visitaselezionata.multipli, 10);
    const postidisponibili = max - prenotati;

    if (this.adulti + this.adultiSoloVisita + this.ridotti + 1 <= postidisponibili) {
      this.ridotti += 1;
    }
  }

  minoriMeno() {
    if (this.minori > 0) {
      this.minori -= 1;
    }
  }

  minoriPiu() {
    const adulti_minori = this.cantina.adulti_minori.split(':');
    const maxMinori = (parseInt(adulti_minori[1], 10) * this.adulti) + (parseInt(adulti_minori[1], 10) * this.adultiSoloVisita);
    if (this.minori < maxMinori) {
      this.minori += 1;
    }
  }

  visualizzaInfoUltimiPosti(): boolean {
    const max = parseInt(this.visitaselezionata.max, 10);
    const prenotati = parseInt(this.visitaselezionata.prenotati, 10);
    const postidisponibili = max - prenotati;
    if (postidisponibili > 1 && postidisponibili < 6) {
      return true;
    } else {
      return false;
    }
  }
  visualizzaInfoUltimoPosto(): boolean {
    const max = parseInt(this.visitaselezionata.max, 10);
    const prenotati = parseInt(this.visitaselezionata.prenotati, 10);
    const postidisponibili = max - prenotati;
    if (postidisponibili === 1) {
      return true;
    } else {
      return false;
    }
  }
  getPostiDisponibili(): number {
    const max = parseInt(this.visitaselezionata.max, 10);
    const prenotati = parseInt(this.visitaselezionata.prenotati, 10);
    const postidisponibili = max - prenotati;
    return postidisponibili;
  }

  visualizzaInfoPostiMinimi() {
    if (this.visitaselezionata.multipli === '1') {
      return false;
    } else {
      if (this.visitaselezionata.prenotati >= this.visitaselezionata.min) {
        if (parseInt(this.visitaselezionata.multipli, 10) > 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }

  }

  continua() {
    let isOk = true;
    let gite = true;
    let opzioni = true;

    if (this.arrayGite && this.arrayGite.length > 0) {
      if (this.parametriOpzioniGita.obbligatorie) {
        const res = this.arrayGite.filter(gita => gita.qta > 0)
        if (res.length == 0) {
          this.erroreGite = true;
          gite = false;
          isOk = false;
          document.querySelector('#section__extra').scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          this.erroreGite = false;
          gite = true;
          isOk = true;
        }
      }
    }

    if (this.arrayOpzioni && this.arrayOpzioni.length > 0) {
      if (this.parametriOpzioniTipoVisita.obbligatorie) {
        const res = this.arrayOpzioni.filter(opzione => opzione.qta > 0);
        if (res.length == 0) {
          this.erroreOpzioni = true;
          opzioni = false;
          isOk = false;
          document.querySelector('#section__extra').scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          this.erroreOpzioni = false;
          opzioni = true;
          isOk = true;
        }
      }
    }

    if (this.controllaFormaLingua() && isOk && gite && opzioni) {
      this.gestisciAzioneContinua();
    }
  }


  controllaFormaLingua(): boolean {
    if (this.formLinguaSelezionata.value.lingua != null) {
      return true;
    } else {
      this.selezionaLingua();
      return false;
    }
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup) {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  visitaHasRange() {
    if (this.visitaselezionata.attivaRange === '1' &&
      (this.visitaselezionata.rangecosti && this.visitaselezionata.rangecosti.length > 0)) {
      return true;
    } else {
      return false;
    }
  }

  get prezzoSoloVisita() {
    let przVisita = 0;
    if (this.visitaselezionata.costo_solovisita) {
      przVisita = this.visitaselezionata.costo_solovisita;
    } else {
      przVisita = 0;
    }
    return przVisita;
  }

  get personeTotali(): number {
    let totale = 0;
    totale = this.adulti + this.minori + this.ridotti + this.adultiSoloVisita;
    return totale;
  }

  gestisciAzioneContinua() {
    const przVisita = parseFloat(this.visitaselezionata.costo);
    const przVisitaSolo = this.prezzoSoloVisita;

    const przRidotti = parseFloat(this.visitaselezionata.costoridotti);

    let totaleAdulti = przVisita * this.adulti;
    let totaleAdultiSoloVisita = przVisitaSolo * this.adultiSoloVisita;

    if (
      this.promoSelezionata && this.promoSelezionata.promo && this.promoSelezionata.risultato
    ) {
      totaleAdulti = this.totadultipromo;
    } else {
      totaleAdulti = przVisita * this.adulti;
    }

    const totaleRidotti = przRidotti * this.ridotti;

    const valori = <any>{};

    valori.idCliente = null;
    valori.idAgenzia = 0;
    valori.idVisita = this.visitaselezionata.id;
    valori.nposti = this.adulti + this.ridotti + this.adultiSoloVisita;
    valori.nadulti = this.adulti;
    valori.nadulti_solovisita = this.adultiSoloVisita;
    valori.nridotti = this.ridotti;
    valori.nminori = this.minori;
    valori.disabili = this.mobridotta;
    valori.promo = this.promoSelezionata && this.promoSelezionata.risultato ? this.promoSelezionata.codice : '';
    valori.codiceForm = this.cantina.codiceForm;
    valori.codiceFormMaster = null;
    valori.totaleadulti = totaleAdulti;
    valori.totaleadulti_solovisita = totaleAdultiSoloVisita;
    valori.totaleridotti = totaleRidotti;
    valori.totale = this.totale;
    valori.totalescontato =
      this.promoSelezionata && this.promoSelezionata.risultato ? this.totalescontato : 0;
    valori.promo_cw_id = '';
    valori.promo_cw_valore = 0;

    valori.linguaSelezionata = this.formLinguaSelezionata.value.lingua;

    const opzioniSelezionate = [];
    const giteSelezionate = [];

    if (this.arrayOpzioni) {
      this.arrayOpzioni.forEach(opzione => {
        if (opzione.qta > 0) {
          opzioniSelezionate.push(opzione);
        }
      });
    }

    if (this.arrayGite) {
      this.arrayGite.forEach(gita => {
        if (gita.qta > 0) {
          giteSelezionate.push(gita);
        }
      });
    }

    valori.opzioniSelezionate = opzioniSelezionate;
    valori.giteSelezionate = giteSelezionate;
    valori.richieste = this.arrayRichieste;

    this.carrelloService.checkPresenzaNelCarrelloIframe(null, this.visitaselezionata.id, this.adulti)
      .subscribe(rigapresente => {
        if (rigapresente && (!rigapresente.pieno && !rigapresente.uguali)) {
          this.addCarrello(valori);
        } else {
          const initialState = {
            titolo: !rigapresente.pieno ? 'carrello_pieno.diag_titolo' : 'carrello_pieno.diag_titolo',
            messaggio: !rigapresente.pieno ? 'carrello_pieno.diag_messaggio' : 'carrello_pieno.diag_messaggio_pieno',
            testoOk: 'generale.ok',
            testoCancel: 'carrello_pieno.diag_vaialcarrello',
            confermaAzione: !rigapresente.pieno && rigapresente.uguali ? false : true,
            visualizzaCancel: rigapresente.uguali
          }
          const dialogRef = this.dialog.open(DialogCarrelloPienoComponent, {
            width: '250px',
            panelClass: 'fixed-dialog-container',
            data: initialState
          });

          dialogRef.afterClosed().subscribe(response => {
            if (response) {
              this.addCarrello(valori);
            } else {
              this.messageService.sendClickMessage(null, null, this.linguaCorrente, 2, this.messageService.getIdCookie());
            }
          });
        }
      });
  }

  addCarrello(valori) {
    this.carrelloService.addCarrello("carrello", valori).subscribe(result => {
      if (result['risultato']) {
        this.router.navigate(['/step2/' + this.messageService.getIdCookie() + '/' + this.translate.currentLang]);
      }
    });
  }

  vaiStep2() {
    const przVisita = parseFloat(this.visitaselezionata.costo);
    const przRidotti = parseFloat(this.visitaselezionata.costoridotti);
    const totaleAdulti = przVisita * this.adulti;
    const totaleRidotti = przRidotti * this.ridotti;

    const valori = {} as any;
    valori.idCliente = null;
    valori.idAgenzia = 0;
    valori.idVisita = this.visitaselezionata.id;
    valori.visita = this.visitaselezionata;
    valori.nposti = this.adulti + this.ridotti;
    valori.nadulti = this.adulti;
    valori.nridotti = this.ridotti;
    valori.nminori = this.minori;
    valori.disabili = this.mobridotta;
    valori.promo = this.promoSelezionata && this.promoSelezionata.risultato ? this.promoSelezionata.codice : '';
    valori.codiceForm = this.cantina.codiceForm;
    valori.denominazione = this.stepService.cantinaDenominazione;
    valori.totaleadulti = totaleAdulti;
    valori.totaleridotti = totaleRidotti;
    valori.totale = this.totale;
    valori.totalescontato = this.promoSelezionata && this.promoSelezionata.risultato ? this.totalescontato : 0;
    valori.promo_cw_id = '';
    valori.promo_cw_valore = 0;
    valori.linguaSelezionata = this.formLinguaSelezionata.value.lingua;

    const opzioniSelezionate = [];
    const giteSelezionate = [];

    if (this.arrayOpzioni) {
      this.arrayOpzioni.forEach(opzione => {
        if (opzione.selezionata) {
          opzioniSelezionate.push(opzione);
        }
      });
    }

    if (this.arrayGite) {
      this.arrayGite.forEach(gita => {
        if (gita.selezionata) {
          giteSelezionate.push(gita);
        }
      });
    }

    valori.opzioniSelezionate = opzioniSelezionate;
    valori.giteSelezionate = giteSelezionate;

    this.stepService.setCarrello(valori);

    this.stepService.currentVisita = this.visitaselezionata;

    this.router.navigate(['/step2']);
  }

  riscattaCodice() {
    const initialState = {
      titolo: 'promodialogo.titolo',
      label: 'promodialogo.label',
      idVisita: this.visitaselezionata.id,
      codiceForm: this.cantina.codiceForm,
      nposti: this.adulti,
      costoTotale: this.totale,
      costoSingolo: parseFloat(this.visitaselezionata.costo)
    };

    const dialogRef = this.dialog.open(DialogPromoComponent, {
      width: '250px',
      data: initialState
    });

    dialogRef.afterClosed().subscribe(result => {
      this.promoSelezionata = result;
      if (result && result.risultato) {
        if (result.promo.npersone) {
          const personePromo = parseInt(result.promo.npersone, 10);
          if (this.getPostiDisponibili() >= personePromo) {
            this.adulti = parseInt(result.promo.npersone, 10);
          }
        }
      }
    });

    /*   this.bsModalRef = this.modalService.show(CodicepromoComponent, { class: 'modal-sm', initialState });

       this.bsModalRef.content.onClose.subscribe(result => {
         this.promoSelezionata = result;
       });
       */
  }

  get prezzoSingolo() {
    let przVisita = 0;
    if (this.visitaHasRange()) {
      const totalIndex = this.visitaselezionata.rangecosti.length - 1;
      for (const range of this.visitaselezionata.rangecosti) {
        const isUltimo = this.visitaselezionata.rangecosti.lastIndexOf(range) == totalIndex ? true : false;
        if (parseInt(range.min, 10) <= this.adulti && (parseInt(range.max, 10) >= this.adulti || isUltimo || parseInt(range.max, 10) == 0)) {
          przVisita = parseFloat(range.costo);
        } else {
        }
      }
      if (przVisita == 0) {
        przVisita = parseFloat(this.visitaselezionata.costo);
      }
    } else {
      przVisita = parseFloat(this.visitaselezionata.costo);
    }
    return przVisita;
  }

  get totaleOpzioni(): number {
    let totale = 0;
    if (this.arrayOpzioni) {
      this.arrayOpzioni.forEach(opzione => {
        if (opzione.selezionata) {
          totale += opzione.qta * opzione.costo;
        }
      });
    }
    return totale;
  }

  get totaleGite(): number {
    let totale = 0;
    if (this.arrayGite) {
      this.arrayGite.forEach(gita => {
        if (gita.selezionata) {
          totale += gita.qta * gita.costo;
        }
      });
    }
    return totale;
  }

  get totale(): number {
    const przVisita = this.prezzoSingolo;
    const przRidotti = parseFloat(this.visitaselezionata.costoridotti);
    const przAdultiSoloVisita = this.visitaselezionata.costo_solovisita ? parseFloat(this.visitaselezionata.costo_solovisita) : 0;
    return (przVisita * this.adulti) + (przRidotti * this.ridotti) + (przAdultiSoloVisita * this.adultiSoloVisita);
  }

  get totaleVisualizzato(): number {
    return this.totale + this.totaleOpzioni + this.totaleGite;
  }

  get totalescontato(): number {

    let totaleScontato = 0;

    if (this.promoSelezionata && this.promoSelezionata.promo) {
      const przvisita = this.prezzoSingolo;

      const totaleadulti = przvisita * this.adulti;

      if ((this.promoSelezionata.codice + '').includes('-')) {
        this.promoSelezionata = this.promoService.controllaRegalo(
          this.promoSelezionata.promo, this.adulti, totaleadulti, przvisita, this.promoSelezionata.codice
        );
      } else {
        this.promoSelezionata = this.promoService.controllaPromo(
          this.promoSelezionata.promo, this.adulti, totaleadulti, przvisita, this.promoSelezionata.codice
        );
      }

      if (this.promoSelezionata.risultato) {
        const totScontato = this.totale - this.promoSelezionata.valore;
        this.totadultipromo = totaleadulti - this.promoSelezionata.valore >= 0 ? totaleadulti - this.promoSelezionata.valore : 0;
        totaleScontato = totScontato >= 0 ? totScontato + this.totaleOpzioni + this.totaleGite : 0;
      } else {
        totaleScontato = this.totale + this.totaleOpzioni + this.totaleGite;
      }
    } else {
      totaleScontato = 0;
    }

    return totaleScontato;
  }

  extrasDisponibili() {
    if (
      (this.arrayOpzioni && this.arrayOpzioni.length > 0) ||
      (this.arrayGite && this.arrayGite.length > 0)
    ) {
      return true;
    } else {
      return false;
    }
  }

  getMsgOpzioni(scelta: number) {
    let msg: string;
    const singole = scelta == 0 ? this.parametriOpzioniTipoVisita.singole : this.parametriOpzioniGita.singole;
    const obbligatorie = scelta == 0 ? this.parametriOpzioniTipoVisita.obbligatorie : this.parametriOpzioniGita.obbligatorie;

    let entity;
    entity = scelta == 0 ? 'opzioni_extra' : 'gite_extra';

    if (obbligatorie) {
      msg = singole ? TRANSLATE(entity + '.singola_obbl') : TRANSLATE(entity + '.multipla_obbl');
    } else {
      msg = singole ? TRANSLATE(entity + '.singola_not_obbl') : TRANSLATE(entity + '.multipla_not_obbl');
    }
    return msg;
  }

  isExtraFree(item) {
    const costo = parseFloat(item.costo);
    return costo == 0 ? true : false;
  }

  isMax(item) {
    let n_qta = parseInt(item.qta, 10);
    const n_massimo_opzione = this.personeTotali;
    const solouna = item.solouna === '1' ? true : false;
    if (solouna) {
      if (n_qta == 1) {
        return true;
      } else {
        return false;
      }
    } else {
      if (n_qta == n_massimo_opzione) {
        return true;
      } else {
        return false;
      }
    }
  }

  getOpzioniExtra(idTipoVisita): void {
    this.visiteService.getOpzioniExtra(this.translate.currentLang, idTipoVisita).subscribe(opzioni => {
      this.arrayOpzioni = opzioni;
    });
  }

  getOpzioniGite(idTipoVisita): void {
    this.visiteService.getOpzioniGite(this.translate.currentLang, idTipoVisita).subscribe(gite => {
      this.arrayGite = gite;
    });
  }

  increaseCountExtra(opzione) {
    if (!(opzione.qta)) {
      opzione.qta = 0;
    }
    let n_qta = parseInt(opzione.qta, 10);
    const n_massimo_opzione = this.personeTotali;
    const solouna = opzione.solouna === '1' ? true : false;
    if (n_massimo_opzione > n_qta) {
      if (n_qta < 1 && solouna) {
        n_qta = n_qta + 1;
        opzione.qta = n_qta;
      } else {
        if (!solouna) {
          n_qta = n_qta + 1;
          opzione.qta = n_qta;
        }
      }
    }

    if (opzione.qta >= 1 && this.parametriOpzioniTipoVisita.singole) {
      this.arrayOpzioni.forEach(item => {
        if (item.id !== opzione.id) {
          item.qta = 0
        }
      });
    }
  }

  decreaseCountExtra(opzione) {
    if (!(opzione.qta)) {
      opzione.qta = 0;
    }
    let n_qta = parseInt(opzione.qta, 10);
    if (n_qta >= 1) {
      n_qta = n_qta - 1;
      opzione.qta = n_qta;
    }
  }

  increaseCountGita(gita) {
    if (!(gita.qta)) {
      gita.qta = 0;
    }
    let n_qta = parseInt(gita.qta, 10);
    const n_massimo_gita = this.personeTotali;
    const solouna = gita.solouna === '1' ? true : false;

    if (n_massimo_gita > n_qta) {
      if (n_qta < 1 && solouna) {
        n_qta = n_qta + 1;
        gita.qta = n_qta;
      } else {
        if (!solouna) {
          n_qta = n_qta + 1;
          gita.qta = n_qta;
        }
      }
    }

    if (gita.qta >= 1 && this.parametriOpzioniGita.singole) {
      this.arrayGite.forEach(item => {
        if (item.id !== gita.id) {
          item.qta = 0
        }
      });
    }
  }

  decreaseCountGita(gita) {
    if (!(gita.qta)) {
      gita.qta = 0;
    }
    let n_qta = parseInt(gita.qta, 10);
    const n_minimo_gita = 1;

    if (n_qta >= n_minimo_gita) {
      n_qta = n_qta - 1;
      gita.qta = n_qta;
    }
  }

  terminiOrNote() {
    let ris = false;
    if ((this.cantina.note_base && this.cantina.note_base.length > 1) || (this.cantina.termini_cancellazione && this.cantina.termini_cancellazione.length > 1)) {
      ris = true;
    }
    return ris;
  }

  showRidotti() {
    if (this.visitaselezionata.consentiridotti === '1' && this.visitaselezionata.ridotti === '1') {
      return true;
    } else {
      return false;
    }
  }

  showAdultiSoloVisita() {
    if (this.visitaselezionata.abilitato_solovisita === '1') {
      return true;
    } else {
      return false;
    }
  }

  selezionaLingua() {
    this.erroreLingua = true;
    document.querySelector('#tipovisita').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  isFree(tipo) {
    switch (tipo) {
      case 1:
        return parseFloat(this.visitaselezionata.costoridotti) == 0 ? true : false;
    }
  }

  showPopUp(scelta) {
    switch (scelta) {
      case 1:
        this.showNote = this.showNote ? false : true;
        this.showTermini = false
        break;
      case 2:
        this.showTermini = this.showTermini ? false : true;
        this.showNote = false
        break;
    }
  }

  sistemaText() {
    this.refactor = !this.refactor;
  }

  get dataSenzaOra() {
    let data = '';
    if (this.linguaCorrente === 'it') {
      data = moment(this.visitaselezionata.data).format('D/MM/YYYY');
    } else {
      data = moment(this.visitaselezionata.data).format('l');
    }
    return data;
  }

  get dataMinima() {
    if (this.visitaHasPernottamento()) {
      if (this.linguaCorrente === 'it') {
        return moment(this.visitaselezionata.data).format('D MMM');
      } else {
        return moment(this.visitaselezionata.data).format('D MMM');
      }
    } else {
      if (this.linguaCorrente === 'it') {
        return moment(this.visitaselezionata.data).format('D MMM HH:mm');
      } else {
        return moment(this.visitaselezionata.data).format('D MMM h:mm A');
      }
    }
  }

  get dataSvolgimento() {
    let data = {};
    data['translation'] = false;
    data['data'] = '';

    if (this.visitaselezionata.svolgimento_esperienza_visita === '1') {
      data['translation'] = false;
      if (this.linguaCorrente === 'it') {
        data['data'] = moment(this.visitaselezionata.data).add(1, 'days').format('D/MM/YYYY');
      } else {
        data['data'] = moment(this.visitaselezionata.data).add(1, 'days').format('l');
      }
    } else {
      switch (this.visitaselezionata.svolgimento_esperienza_visita) {
        case '0':
          data['translation'] = true;
          data['data'] = 'prenotazioni.stessadata';
          break;
        case '2':
          data['translation'] = true;
          data['data'] = 'prenotazioni.datasceltaopzione';
          break;
        case '3':
          data['translation'] = true;
          data['data'] = 'prenotazioni.daconcordare';
          break;
        default:
          data['translation'] = true;
          data['data'] = 'prenotazioni.stessadata';
          break;
      }
    }
    return data;
  }

  showOrari() {
    if (this.dateTipoVistaSelezionata.length == 1 && this.visitaHasPernottamento()) {
      return false;
    } else {
      return true;
    }
  }

  visitaHasPernottamento() {
    return this.visitaselezionata.tipo.includes('P');
  }

  goToCalendario() {
    document.querySelector('#anchor__dropdown').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  goToLingua() {
    if (!this.formLinguaSelezionata.value.lingua) {
      document.querySelector('#anchor__dropdown').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  attivaDropdown(scelta: number) {
    if (this.dropdown_attivo && this.dropdown_attivo == scelta) {
      this.dropdown_attivo = null;
    } else {
      this.dropdown_attivo = scelta;
      document.querySelector('#anchor__dropdown').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (scelta === 1) {
      setTimeout(() => {
        this.aggiungiDataLingueAttr();
        this.agganciaEventiCambioMese()
      }, 0);
    }
  }

  get linguaScelta(): string {
    let lingua = '';
    if (!this.formLinguaSelezionata.value.lingua) {
      lingua = 'pagina_acquisto.label_lingua';
    } else {
      lingua = this.formLinguaSelezionata.value.lingua;
    }
    return lingua.toLowerCase();
  }
}
